module.exports = __webpack_public_path__ + "img/home_25.1037aad5.png";